const NoOrders = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={235}
    height={235}
    fill='none'
    viewBox='0 0 235 235'
    {...props}
  >
    <path
      fill='url(#paint0_linear_1457_90275)'
      d='M63.192 76.769v133.469l19.217-11.687 19.218 11.687 19.218-11.687 19.215 11.687 19.22-11.687 19.216 11.687 19.215-11.687 19.22 11.687V46.514c0-10.86-8.786-19.664-19.63-19.664H43.566'
    ></path>
    <path
      fill='url(#paint1_linear_1457_90275)'
      d='M23.939 126.024h39.253V44.766c0-9.894-8.004-17.912-17.879-17.912h-3.499c-9.872 0-17.878 8.018-17.878 17.912v81.258z'
    ></path>
    <path
      fill='#F00909'
      d='M216.936 145.911a3.575 3.575 0 0 0 3.572-3.58V46.514c0-12.818-10.405-23.245-23.197-23.245H43.566c-12.791 0-23.2 10.43-23.2 23.245v57.045a3.577 3.577 0 0 0 3.573 3.579 3.576 3.576 0 0 0 3.572-3.579V46.514c0-8.87 7.201-16.085 16.053-16.085s16.053 7.217 16.053 16.085v75.926H27.513v-5.784a3.577 3.577 0 0 0-3.572-3.58 3.585 3.585 0 0 0-3.574 3.583v9.363a3.577 3.577 0 0 0 3.572 3.58h35.68v80.636a3.576 3.576 0 0 0 5.426 3.06l17.364-10.559 17.364 10.559a3.57 3.57 0 0 0 3.708 0l17.364-10.559 17.364 10.559a3.57 3.57 0 0 0 3.708 0l17.363-10.559 17.364 10.559a3.57 3.57 0 0 0 3.708 0l17.364-10.559 17.361 10.559a3.55 3.55 0 0 0 3.609.058 3.57 3.57 0 0 0 1.817-3.118v-54.807a3.575 3.575 0 0 0-3.572-3.58 3.575 3.575 0 0 0-3.572 3.58v48.449l-13.792-8.387a3.56 3.56 0 0 0-3.708 0l-17.361 10.56-17.364-10.56a3.55 3.55 0 0 0-3.707 0l-17.364 10.56-17.362-10.56a3.55 3.55 0 0 0-3.707 0l-17.367 10.56-17.364-10.56a3.55 3.55 0 0 0-3.705 0l-13.792 8.387V46.514c0-6.238-2.47-11.907-6.475-16.085h137.023c8.852 0 16.05 7.217 16.05 16.085v95.817a3.578 3.578 0 0 0 3.572 3.58'
    ></path>
    <rect width='38' height='10' x='85' y='69' fill='#fff' rx='5'></rect>
    <rect width='59' height='10' x='130' y='69' fill='#fff' rx='5'></rect>
    <rect width='61' height='10' x='85' y='93' fill='#fff' rx='5'></rect>
    <rect width='40' height='10' x='85' y='139' fill='#fff' rx='5'></rect>
    <rect width='99' height='10' x='85' y='116' fill='#fff' rx='5'></rect>
    <defs>
      <linearGradient
        id='paint0_linear_1457_90275'
        x1='130.249'
        x2='130.249'
        y1='26.85'
        y2='210.238'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90A0A'></stop>
        <stop offset='0.809' stopColor='#F00909'></stop>
      </linearGradient>
      <linearGradient
        id='paint1_linear_1457_90275'
        x1='43.564'
        x2='43.564'
        y1='26.854'
        y2='126.024'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#771616'></stop>
        <stop offset='1' stopColor='#E50A0A'></stop>
      </linearGradient>
    </defs>
  </svg>
);
export default NoOrders;
